import React, { useState, useEffect } from 'react';
import Button from '@mui/material/Button';
import { Input, Row, Col, Card, Space, Modal } from 'antd';
import ContentEditor from '../../SuperComponents/ContentEditor/ContentEditor';
import {CollectionsRounded} from "@mui/icons-material";
import ResponseCollection from "../../SuperComponents/Gpt/ResponseCollection";
import Files from "../../Pages/Files/Files";


const TouchpointEditor = ({ touchpoint, onSave, onChangeTitle, onChangeContent }) => {
    const [localTouchpoint, setLocalTouchpoint] = useState(touchpoint);
    const [showFiles, setShowFiles] = useState(false);

    useEffect(() => {
        setLocalTouchpoint(touchpoint);  // Synchronize external changes
    }, [touchpoint]);

    const handleSave = () => {
        onSave(localTouchpoint);
    };

    const handleTitleChange = (e) => {
        const updatedTouchpoint = { ...localTouchpoint, title: e.target.value };
        setLocalTouchpoint(updatedTouchpoint);
        onChangeTitle(updatedTouchpoint.title);
    };

    const handleContentChange = (newContent) => {
        const updatedTouchpoint = { ...localTouchpoint, content: newContent };
        setLocalTouchpoint(updatedTouchpoint);
        onChangeContent(newContent);
    };

    return (
        <Row>
            <Col flex={'0 0 840px'}>
                <Card bordered={false} style={{height: 850, overflowY: 'scroll', padding: 0}}>
                    <Row align={'middle'} justify={'space-between'} className={'px-3'} wrap={false}>
                        <Col flex={'0 0 250px'}>
                            <Input
                                value={localTouchpoint?.title || ''}
                                onChange={handleTitleChange}
                                placeholder="Enter Touchpoint Title"
                                style={{ width: '100%', padding: '10px', margin: '20px 0' }}
                            />
                        </Col>
                        <Space size={'middle'}>
                            <Button onClick={()=>setShowFiles(true)}>
                                <CollectionsRounded/>
                            </Button>
                            <Button variant="contained" color="primary" onClick={handleSave}>
                                Save Touchpoint
                            </Button>
                        </Space>
                    </Row>
                    <ContentEditor initialData={localTouchpoint.content} onContentChange={handleContentChange} />
                </Card>
            </Col>
            <Col flex={'1 1 300px'} offset={1}>
                <ResponseCollection />
            </Col>
            <Modal open={showFiles} onOk={()=>setShowFiles(false)} onCancel={()=>setShowFiles(false)} width={'100%'} style={{height: '90%'}}>
                <Files/>
            </Modal>
        </Row>
    );
};

export default TouchpointEditor;
